import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from "@Core/Components/Loading";
import Header from '@Core/Components/Layout/Component/Header';
import Footer from '@Core/Components/Layout/Component/Footer';

const SessionTimeOut = () => {
    let loader = useSelector((state) => state.commonReducer.loader) || false;
    let loaderData = useSelector((state) => state.commonReducer.loaderData) || '';
    return (
        <div className="d-flex flex-column h-100">
            <Loader loading={loader} msg={loaderData}></Loader>
            <Header />
            <main className="form-signin w-100 m-auto">
                <div className="bodyContent">
                    <div className='invalid-cont'>
                        <div className="d-flex flex-column justify-content-between">
                            <div className="invalid-msg text-center">
                                <img src="./img/cross-circle.svg" className="my-3" alt="logo" width="80" />
                                <p className="normalText mb-3">Authorization failed. Please Contact Support</p>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    )
}

export default SessionTimeOut
